var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.91 23.51H25.38C25.1148 23.51 24.8604 23.6154 24.6729 23.8029C24.4854 23.9904 24.38 24.2448 24.38 24.51C24.38 24.7752 24.4854 25.0296 24.6729 25.2171C24.8604 25.4046 25.1148 25.51 25.38 25.51H27.78C26.6769 26.6627 25.2544 27.4593 23.6952 27.7974C22.1359 28.1355 20.5112 27.9996 19.0298 27.4072C17.5483 26.8149 16.2779 25.7931 15.3816 24.4732C14.4853 23.1532 14.0042 21.5955 14 20C14 19.7348 13.8946 19.4804 13.7071 19.2929C13.5196 19.1054 13.2652 19 13 19C12.7348 19 12.4804 19.1054 12.2929 19.2929C12.1054 19.4804 12 19.7348 12 20C12.0053 21.9528 12.5822 23.8613 13.6596 25.49C14.737 27.1187 16.2677 28.3964 18.0627 29.1652C19.8578 29.9341 21.8387 30.1605 23.761 29.8166C25.6833 29.4727 27.4628 28.5735 28.88 27.23V29C28.88 29.2652 28.9854 29.5196 29.1729 29.7071C29.3604 29.8946 29.6148 30 29.88 30C30.1452 30 30.3996 29.8946 30.5871 29.7071C30.7746 29.5196 30.88 29.2652 30.88 29V24.5C30.8775 24.2416 30.7752 23.9943 30.5943 23.8097C30.4135 23.6251 30.1683 23.5177 29.91 23.51ZM22 10C19.4364 10.0073 16.9735 10.9989 15.12 12.77V11C15.12 10.7348 15.0146 10.4804 14.8271 10.2929C14.6396 10.1054 14.3852 10 14.12 10C13.8548 10 13.6004 10.1054 13.4129 10.2929C13.2254 10.4804 13.12 10.7348 13.12 11V15.5C13.12 15.7652 13.2254 16.0196 13.4129 16.2071C13.6004 16.3946 13.8548 16.5 14.12 16.5H18.62C18.8852 16.5 19.1396 16.3946 19.3271 16.2071C19.5146 16.0196 19.62 15.7652 19.62 15.5C19.62 15.2348 19.5146 14.9804 19.3271 14.7929C19.1396 14.6054 18.8852 14.5 18.62 14.5H16.22C17.3225 13.3479 18.7441 12.5515 20.3024 12.2131C21.8607 11.8747 23.4846 12.0097 24.9656 12.6009C26.4466 13.192 27.7172 14.2122 28.6142 15.5306C29.5113 16.849 29.9938 18.4054 30 20C30 20.2652 30.1054 20.5196 30.2929 20.7071C30.4804 20.8946 30.7348 21 31 21C31.2652 21 31.5196 20.8946 31.7071 20.7071C31.8946 20.5196 32 20.2652 32 20C32 18.6868 31.7413 17.3864 31.2388 16.1732C30.7362 14.9599 29.9997 13.8575 29.0711 12.9289C28.1425 12.0003 27.0401 11.2638 25.8268 10.7612C24.6136 10.2587 23.3132 10 22 10Z",
    fill: "url(#paint0_linear_4244_6286)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 39,
    rx: 7.5,
    stroke: "url(#paint1_linear_4244_6286)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4244_6286",
    x1: 12,
    y1: 20.1266,
    x2: 32.3191,
    y2: 20.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4244_6286",
    x1: 5.56006e-8,
    y1: 20.2532,
    x2: 44.7021,
    y2: 20.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D592"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.597c5212be9add47aac3c7130147683e.svg";
export { ForwardRef as ReactComponent };